export const recommendedImageSize = {
  width: 968,
  height: 545
}
